import styled from 'styled-components';

const OfferDetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const OfferInfoWrapper = styled.div`
  color: var(--cvna-color-blue-6);
`;

const OfferTitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #6d7184;
  text-transform: capitalize;
`;

const OfferAmount = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
`;

export { OfferDetailsWrapper, OfferInfoWrapper, OfferTitle, OfferAmount };
